<template>
  <div>
    <div class="flex p-4 items-end relative xl:grid three-columns xl:items-center" :class="{'h-32': !slim, 'h-20': slim, 'brand-gradient': color == 'red', 'quiz-gradient': color == 'purple'}">   
      <div class="self-center hidden xl:flex col-start-1 items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.97 27.55" width="91.97" height="27.55">
          <path fill="#fff" d="M6.07 24.45a2.13 2.13 0 01-1.6-.51A2.71 2.71 0 014 22.08V.76H0v21.65a5.53 5.53 0 001.18 3.88 4.8 4.8 0 003.66 1.25 8.33 8.33 0 001.64-.16 6.56 6.56 0 001.46-.46l.44-2.91a8.34 8.34 0 01-1.17.35 6 6 0 01-1.14.09zM11.73 8.96h3.98v18.22h-3.98zM15.57 6.12L12.85 0H8.83l3.68 6.12zM86.56 6.12L83.84 0h-4.02l3.69 6.12zM32.7 25.09a5.52 5.52 0 00.8-1.33l.2 3.42h3.54V.76h-3.98v11.26a6.1 6.1 0 00-1.75-2.15 6.35 6.35 0 00-4.02-1.27 8.38 8.38 0 00-4.25 1.11 8.09 8.09 0 00-3.09 3.22A10.67 10.67 0 0019 18.11a11 11 0 001.08 5.06 7.83 7.83 0 002.96 3.24 7.98 7.98 0 004.19 1.13 7.48 7.48 0 003.07-.63 6.43 6.43 0 002.4-1.83zm-8.38-2.37a7.3 7.3 0 01-1.34-4.65 7.08 7.08 0 011.38-4.63 5.23 5.23 0 016.5-.94 4.83 4.83 0 011.77 2.1 7.7 7.7 0 01.63 3.25 8.75 8.75 0 01-.63 3.5 5.18 5.18 0 01-1.8 2.26 4.71 4.71 0 01-2.75.8 4.52 4.52 0 01-3.76-1.7zM56.07 23.2v-8.12a6.25 6.25 0 00-.99-3.64 6 6 0 00-2.7-2.13 10.24 10.24 0 00-3.95-.71 9.62 9.62 0 00-5.34 1.35 6.55 6.55 0 00-2.78 3.57l3.36 1.38a4.44 4.44 0 011.75-2.48 5.2 5.2 0 012.86-.76 3.85 3.85 0 012.82 1 3.77 3.77 0 011.02 2.82v.7l-6.63 1.27a7.4 7.4 0 00-3.85 1.79 4.45 4.45 0 00-1.36 3.35 4.58 4.58 0 00.8 2.75 4.77 4.77 0 002.2 1.66 8.58 8.58 0 003.14.55 8.86 8.86 0 002.8-.46 6.8 6.8 0 002.42-1.38 4.38 4.38 0 00.71-.82 3.24 3.24 0 001.88 2.16 5.26 5.26 0 002.14.42 5.1 5.1 0 002.16-.4l.22-2.7a4.69 4.69 0 01-1.3.19 1.2 1.2 0 01-1.38-1.35zm-3.95-2.76a4.16 4.16 0 01-.4 1.88 3.35 3.35 0 01-1.1 1.27 4.78 4.78 0 01-1.57.71 7.43 7.43 0 01-1.81.22 3.48 3.48 0 01-2.14-.6 1.92 1.92 0 01-.8-1.62 1.83 1.83 0 01.78-1.6 6.13 6.13 0 012.35-.84l4.69-.94zM61.84 22.37a5.65 5.65 0 00.78 3 4.19 4.19 0 002.1 1.66 8.22 8.22 0 002.93.51 8.7 8.7 0 002.78-.41 6.3 6.3 0 002.1-1.15l-.9-2.84a5.09 5.09 0 01-1.37.85 4.54 4.54 0 01-1.76.31 2.91 2.91 0 01-1.95-.62 2.45 2.45 0 01-.73-1.97v-9.69h6.41V8.96h-6.4V3.61L61.83 4.7v4.26h-3.57v3.06h3.57zM90.97 12.68a7.39 7.39 0 00-2.9-2.99 9.12 9.12 0 00-4.63-1.09 9.77 9.77 0 00-4.73 1.13A8.02 8.02 0 0075.45 13a11.6 11.6 0 000 10.17 7.96 7.96 0 003.3 3.26 10.3 10.3 0 004.92 1.13 11 11 0 003.42-.51 7.9 7.9 0 002.7-1.48 7.36 7.36 0 001.8-2.27l-3.16-1.46a4.94 4.94 0 01-1.82 1.93 5.82 5.82 0 01-3.02.7 5.59 5.59 0 01-2.9-.74 4.8 4.8 0 01-1.9-2.15 7.19 7.19 0 01-.61-2.33h13.65a10.08 10.08 0 00.1-1.02q.04-.58.04-1.24a9.03 9.03 0 00-1-4.3zm-12.7 3.57a7.1 7.1 0 01.48-1.66 4.64 4.64 0 011.83-2.16 5.25 5.25 0 012.79-.73 4.56 4.56 0 013.46 1.33 4.99 4.99 0 011.25 3.22z"/>
        </svg>
      </div>

      <div class="col-start-2 text-white font-display text-2xl hidden xl:flex" v-show="menu">
        <router-link class="mr-8" :class="{'font-bold' : active === 'Profile'}" :to="{name: 'Overview'}">{{$t('profile.page-label')}}</router-link>
        <router-link class="mr-8" :class="{'font-bold' : active === 'Survey'}" :to="{name: 'SurveyList'}">{{$t('surveys.page-label')}}</router-link>
        <router-link class="mr-8" :class="{'font-bold' : active === 'Maps'}" :to="{name: 'Maps'}">{{$t('maps.page-label')}}</router-link>
        <router-link class="mr-8" :class="{'font-bold' : active === 'Quiz'}" :to="{name: 'Quiz'}">{{$t('quiz.page-label')}}</router-link>
      </div>

      <div class="hidden xl:flex col-start-3 items-center justify-end pr-6" v-show="menu">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.86 33.88" width="23.888" height="27.104" class="mr-8 cursor-pointer" @click="openNotifications()">
          <path :fill="notifications.length ? '#fff' : 'none'" stroke="#fff" stroke-width="2" stroke-miterlimit="10" d="M26.56 25.65H3.25A2.5 2.5 0 01.6 23.31v-.07a2 2 0 01.68-1.67l.28-.28c1.17-1.16 2.94-2.9 2.94-8.02a9.76 9.76 0 017.8-9.26v-.67A2.52 2.52 0 0114.9.9a2.53 2.53 0 012.62 2.43V4a9.76 9.76 0 017.78 9.26c0 5.11 1.77 6.86 2.94 8.02l.28.28a2.3 2.3 0 01.74 1.63v.04a2.6 2.6 0 01-2.7 2.41zM14.96 32.97a4.4 4.4 0 01-4.6-4.17v-.74h9.13v.65a4.34 4.34 0 01-4.43 4.26h-.1z"/>
        </svg>
        <div class="rounded-md h-12 w-12 overflow-hidden mr-2 cursor-pointer border-4 border-transparent relative flex"
          :class="{
            'border-white': profileMenuOpen,
          }"
          @click.stop="openProfileMenu()"
        >
          <div
            class="bg-center bg-cover bg-no-repeat m-1 bg-white flex-1 overflow-hidden rounded-md"
            :style="{
              backgroundImage: $store.getters.userPic ? `url('${$store.getters.userPic}')` : false,
            }"
          ></div>

        </div>
      </div>

      <div class="col-start-3 hidden xl:block absolute bottom-0 h-0 w-full pl-3 z-30" v-show="menu && profileMenuOpen">
        <div class="bg-white shadow-md innermenu flex flex-col">
          <router-link class="p-4 h-20 flex items-center border-b border-line" :to="{name: 'Profile'}">Profilo Personale</router-link>
          <router-link class="p-4 h-20 flex items-center border-b border-line" :to="{name: 'guide'}">Guida</router-link>
          <router-link class="p-4 h-20 flex items-center border-b border-line" :to="{name: 'privacypolicy'}">Trattamento Dati</router-link>
          <button class="p-4 h-20 flex items-center font-bold" @click="logout">Esci</button>
        </div>
      </div>

      <div class="col-start-3 hidden xl:block absolute bottom-0 h-0 w-full pl-3 z-30" v-show="menu && notificationsOpen">
        <div class="bg-white shadow-md innermenu innermenu2 flex flex-col">
          <router-link class="p-4 h-20 flex items-center justify-start border-b border-line" v-for="(n, i) in notifications" :key="`n${i}`" :to="n.route">
            <div v-html="iconHtml(n.icon)"></div>
            <div class="ml-3">
              <div class="font-bold">{{n.title}}</div>
              <div class="">{{n.subtitle}}</div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="flex items-end relative w-full xl:hidden">
        <slot>
          <div class="w-12 h-12 flex justify-center items-center absolute" v-if="showBack" @click="$emit('back')">
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 35"><path d="M40,21.275H6.25l8.713-8.712a.725.725,0,0,0-1.025-1.025l-9.9,9.9a.882.882,0,0,0,0,1.126l9.9,9.9a.725.725,0,0,0,1.025-1.025L6.25,22.725H40a.725.725,0,0,0,0-1.45Z" fill="#fff"/></svg>
          </div>
          <div class="flex-1 text-white font-bold text-2xl text-center xl:hidden" v-if="title">
            {{title}}
          </div>
          <div class="flex-1 flex justify-evenly h-12 items-center" :class="{'pl-12': showBack}"  v-if="progressMax && !title">
            <span class="md:flex-1 md:mx-4 h-10 w-10 rounded-sm bg-white" :class="{'bg-opacity-50': progressIndex < (i-1)}" v-for="i of progressMax" :key="i"></span>
          </div>
        </slot>
      </div>

    </div>
    <div v-if="(title && largeTitle) || showBack || progressMax" class="hidden xl:grid three-columns items-center bg-white h-20" :class="{'text-brand-1': color == 'red', 'text-quiz-1': color == 'purple'}">
      <div class="col-start-2 flex items-center">
        <div v-if="showBack" class="cursor-pointer mr-8"  @click="$emit('back')">
          <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 35"><path d="M40,21.275H6.25l8.713-8.712a.725.725,0,0,0-1.025-1.025l-9.9,9.9a.882.882,0,0,0,0,1.126l9.9,9.9a.725.725,0,0,0,1.025-1.025L6.25,22.725H40a.725.725,0,0,0,0-1.45Z" fill="currentColor"/></svg>
        </div>
        <div class="flex-1 font-bold text-2xl text-center" v-if="(title && largeTitle)">
          {{title}}
        </div>
        <div class="flex flex-1 justify-evenly h-12 items-center" v-else-if="progressMax">
          <span class="flex-1 mx-4 h-10 rounded-md" :class="{
            'bg-brand-1': progressIndex >= (i-1) && color==='red',
            'bg-quiz-1': progressIndex >= (i-1) && color==='purple',
            'bg-secondary_text': progressIndex < (i-1)
          }" v-for="i of progressMax" :key="i"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { icons, getIconHtml } from '@/services/icons'



export default {
  data() {
    return {
      profileMenuOpen: false,
      notificationsOpen: false
    }
  },
  props: {
    title: String,
    largeTitle: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Boolean,
      default: true
    },
    slim: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'red',
    },
    progressIndex: {
      type: Number,
      default: 0,
    },
    progressMax: {
      type: Number,
      default: 0,
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("wordmaps", ["mapUrls"]),
    ...mapGetters("surveys", ["words", "incompleteSurveys"]),
    ...mapState("quiz", { quizStatus: "status" }),

    notifications() {
      const quizzes = []
      if(this.quizStatus) {
        if(this.quizStatus.isCurrent && !this.quizStatus.answered) {
          quizzes.push({icon: 'quiz', title: 'Nuovo quiz', subtitle: '', route: {name: 'Quiz'}})
        }
      }

      const newMaps = this.words
        .filter(w => w.visited === false && this.mapUrls && w.word in this.mapUrls)
        .map(w => ({icon: 'maps', title: 'Nuova mappa', subtitle: w.word, route: {name: 'MapsDetail', params: {id: w.word}}}))
      const maps = newMaps.length < 3 ? newMaps : [{icon: 'maps', title: 'Nuove mappe', subtitle: `Hai accesso a ${newMaps.length} nuove mappe`, route: {name: 'Maps'}}]

      const newSurveys = this.incompleteSurveys
        .map(s => ({icon: 'survey', title: 'Come lo dici?', subtitle: s.title, route: {name: 'Survey', params: {id: s.id}}}))

      return [...quizzes,...newSurveys,...maps]
    },
    active() {
      switch (this.$route.name) {
        case 'Overview':
        case 'Profile':
          return 'Profile'
          
        case 'Survey':
        case 'SurveyList':
          return 'Survey'
          
        case 'Maps':
        case 'MapsDetail':
          return 'Maps'
          
        default:
          return this.$route.name
      }
    },
  },
  watch: {
    $route() {
      this.closeProfileMenu()
      this.closeNotifications()
    }
  },
  methods: {
    ...mapActions(['logout']),
    iconHtml(icon) {
      if(icon && icons[icon]) {
        return getIconHtml(icons[icon], 32)
      } 
      return ''
    },

    closeProfileMenu(e) {
      window.document.body.removeEventListener('touchstart', this.closeProfileMenu)
      window.document.body.removeEventListener('mousedown', this.closeProfileMenu)
      if(e && e.target) {
        const isMenu = e.target.closest('.innermenu')
        if(!isMenu) {
          this.profileMenuOpen = false
        }
      }
    },
    closeNotifications(e) {
      window.document.body.removeEventListener('touchstart', this.closeNotifications)
      window.document.body.removeEventListener('mousedown', this.closeNotifications)
      if(e && e.target) {
        const isMenu = e.target.closest('.innermenu')
        if(!isMenu) {
          this.notificationsOpen = false
        }
      }
    },
    openProfileMenu() {
      this.profileMenuOpen = true
      this.notificationsOpen = false
      window.document.body.addEventListener('touchstart', this.closeProfileMenu, {capture: true})
      window.document.body.addEventListener('mousedown', this.closeProfileMenu, {capture: true})
    },
    openNotifications() {
      if(this.notifications.length > 0) {
        this.notificationsOpen = true
        this.profileMenuOpen = false
        window.document.body.addEventListener('touchstart', this.closeNotifications, {capture: true})
        window.document.body.addEventListener('mousedown', this.closeNotifications, {capture: true})
      }
    }
  }

}
</script>

<style scoped>

.innermenu::before {
  content: "";
  position: absolute;
  top: -0.5rem;
  right: 4rem;
  width: 0; 
  height: 0; 
  border-left: .5rem solid transparent;
  border-right: .5rem solid transparent;
  border-bottom: .5rem solid white;
}

.innermenu2::before {
  right: 8.25rem;
}
</style>